/* eslint-disable camelcase */
import React from "react";
import { SizeIcon } from "components/Icons";

const formatNumberComma = (value: string): string => {
    const numberVal = parseInt(value, 10);
    return Number.isNaN(numberVal) ? value : new Intl.NumberFormat("en-US").format(numberVal);
};

const formatCompanySize = (size: string): string => {
    const sizes = size?.split("_").map((companySize) => formatNumberComma(companySize));
    return sizes?.[1] === "plus" ? `${sizes[0]}+` : sizes?.join(" - ");
};

interface EmployeeRangeProps {
    employee_range: string;
}

/**
 * Renders the employee range with its associated icon.
 */
const EmployeeRange = (props: EmployeeRangeProps) => {
    const { employee_range = "" } = props;
    const employees = formatCompanySize(employee_range);
    return (
        <li>
            <SizeIcon />
            <span>
                {employees}
                {" employees"}
            </span>
        </li>
    );
};
EmployeeRange.displayName = "EmployeeRange";

export { EmployeeRange };
